import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import { useProjectModel } from '../../model.js';
import { EnvRemove } from './EnvRemove.js';

export const EnvRemoveCommand: FC<{
  variableKey: string;
}> = ({ variableKey }) => {
  const {
    model: {
      config: { siteId },
    },
  } = useProjectModel();

  return (
    <SiteAuthProvider siteId={siteId}>
      <EnvRemove variableKey={variableKey} />
    </SiteAuthProvider>
  );
};
